import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../../i18n/useLanguage";
import { OrderItemTire } from "../../../../stores/slices/cartSlice";
import { KeyValue } from "../../../../ui/KeyValue/KeyValue";
import { fixTireImageUrl } from "../../../../util/fixTireImageUrl";
import { getTiresizeAndClass } from "../../../../util/getTireClassAndSize";
import { getTirePartNumber } from "../../../Tires/Common/getTirePartNumber";
import { CartPrintPrice } from "../CartPrintPrice";
import { LineItems } from "./LineItems/LineItems";

type OrderItemProps = {
  orderItem: OrderItemTire;
};

export const CartPrintItemTire: FunctionComponent<OrderItemProps> = ({
  orderItem,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  return (
    <div className="border border-edge p-4 rounded-section grid grid-cols-9 gap-x-2 items-center">
      <div className="row-span-2 h-full">
        <img
          className={clsx(
            "w-full bg-input rounded-tw-lg object-cover object-center",
            "text-transparent scale-x-[-1] aspect-square"
          )}
          src={fixTireImageUrl(
            orderItem.itemPart.partDetails.primaryPart.tireImageLink
          )}
          alt="Product Image"
        />
      </div>
      <div className="flex items-center col-span-8">
        <h3 className="flex-1 text-lg mb-2 font-medium">
          {orderItem.itemTitle[language] || orderItem.itemTitle["en"]}
        </h3>
        <img
          alt="Manufacturer Logo"
          className="w-32 object-cover object-center text-transparent"
          src={orderItem.itemPart.partDetails.primaryPart.tireManufacturerImage}
        />
      </div>
      <div className="col-span-4">
        <KeyValue>
          <>{t("searchResults.partNumber")}:</>
          <>{getTirePartNumber(orderItem.itemPart)}</>
        </KeyValue>
        <KeyValue>
          <>{t("searchResults.tireSize")}:</>
          <>{getTiresizeAndClass(orderItem.itemPart)}</>
        </KeyValue>
        <KeyValue>
          <>{t("searchResults.loadSpeedPly")}:</>
          <>
            {orderItem.itemPart.partDetails.primaryPart.tireLoadRating}/
            {orderItem.itemPart.partDetails.primaryPart.tireSpeedIndex}/
            {orderItem.itemPart.partDetails.primaryPart.tirePlyRating}
          </>
        </KeyValue>
      </div>
      <CartPrintPrice orderItem={orderItem} />
      <LineItems orderItem={orderItem} />
    </div>
  );
};
